/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql.generated'

const defaultOptions = {} as const
export type PatientQuestionnaireAssignmentsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type PatientQuestionnaireAssignmentsQuery = {
  __typename?: 'Query'
  patientQuestionnaireAssignments: Array<{
    __typename?: 'QuestionnaireAssignment'
    assignmentID: string
    uid: string
    questionnaire: Types.AssignableQuestionnaire
    coachID: string
    assignedAt: Date
    completedAt?: Date | null
  }>
}

export type AssignQuestionnaireToPatientMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  questionnaire: Types.AssignableQuestionnaire
}>

export type AssignQuestionnaireToPatientMutation = {
  __typename?: 'Mutation'
  assignQuestionnaireToPatient: {
    __typename?: 'QuestionnaireAssignment'
    assignmentID: string
    questionnaire: Types.AssignableQuestionnaire
    assignedAt: Date
    completedAt?: Date | null
  }
}

export type RemoveQuestionnaireAssignmentMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  assignmentID: Types.Scalars['ID']['input']
}>

export type RemoveQuestionnaireAssignmentMutation = {
  __typename?: 'Mutation'
  removeQuestionnaireAssignment?: null | null
}

export const PatientQuestionnaireAssignmentsDocument = gql`
  query patientQuestionnaireAssignments($uid: ID!) {
    patientQuestionnaireAssignments(uid: $uid) {
      assignmentID
      uid
      questionnaire
      coachID
      assignedAt
      completedAt
    }
  }
`

/**
 * __usePatientQuestionnaireAssignmentsQuery__
 *
 * To run a query within a React component, call `usePatientQuestionnaireAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientQuestionnaireAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientQuestionnaireAssignmentsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function usePatientQuestionnaireAssignmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PatientQuestionnaireAssignmentsQuery,
    PatientQuestionnaireAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PatientQuestionnaireAssignmentsQuery, PatientQuestionnaireAssignmentsQueryVariables>(
    PatientQuestionnaireAssignmentsDocument,
    options
  )
}
export function usePatientQuestionnaireAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PatientQuestionnaireAssignmentsQuery,
    PatientQuestionnaireAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PatientQuestionnaireAssignmentsQuery, PatientQuestionnaireAssignmentsQueryVariables>(
    PatientQuestionnaireAssignmentsDocument,
    options
  )
}
export type PatientQuestionnaireAssignmentsQueryHookResult = ReturnType<typeof usePatientQuestionnaireAssignmentsQuery>
export type PatientQuestionnaireAssignmentsLazyQueryHookResult = ReturnType<
  typeof usePatientQuestionnaireAssignmentsLazyQuery
>
export type PatientQuestionnaireAssignmentsQueryResult = Apollo.QueryResult<
  PatientQuestionnaireAssignmentsQuery,
  PatientQuestionnaireAssignmentsQueryVariables
>
export const AssignQuestionnaireToPatientDocument = gql`
  mutation assignQuestionnaireToPatient($uid: ID!, $questionnaire: AssignableQuestionnaire!) {
    assignQuestionnaireToPatient(uid: $uid, questionnaire: $questionnaire) {
      assignmentID
      questionnaire
      assignedAt
      completedAt
    }
  }
`
export type AssignQuestionnaireToPatientMutationFn = Apollo.MutationFunction<
  AssignQuestionnaireToPatientMutation,
  AssignQuestionnaireToPatientMutationVariables
>

/**
 * __useAssignQuestionnaireToPatientMutation__
 *
 * To run a mutation, you first call `useAssignQuestionnaireToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignQuestionnaireToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignQuestionnaireToPatientMutation, { data, loading, error }] = useAssignQuestionnaireToPatientMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      questionnaire: // value for 'questionnaire'
 *   },
 * });
 */
export function useAssignQuestionnaireToPatientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignQuestionnaireToPatientMutation,
    AssignQuestionnaireToPatientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AssignQuestionnaireToPatientMutation, AssignQuestionnaireToPatientMutationVariables>(
    AssignQuestionnaireToPatientDocument,
    options
  )
}
export type AssignQuestionnaireToPatientMutationHookResult = ReturnType<typeof useAssignQuestionnaireToPatientMutation>
export type AssignQuestionnaireToPatientMutationResult = Apollo.MutationResult<AssignQuestionnaireToPatientMutation>
export type AssignQuestionnaireToPatientMutationOptions = Apollo.BaseMutationOptions<
  AssignQuestionnaireToPatientMutation,
  AssignQuestionnaireToPatientMutationVariables
>
export const RemoveQuestionnaireAssignmentDocument = gql`
  mutation removeQuestionnaireAssignment($uid: ID!, $assignmentID: ID!) {
    removeQuestionnaireAssignment(uid: $uid, assignmentID: $assignmentID)
  }
`
export type RemoveQuestionnaireAssignmentMutationFn = Apollo.MutationFunction<
  RemoveQuestionnaireAssignmentMutation,
  RemoveQuestionnaireAssignmentMutationVariables
>

/**
 * __useRemoveQuestionnaireAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveQuestionnaireAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuestionnaireAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuestionnaireAssignmentMutation, { data, loading, error }] = useRemoveQuestionnaireAssignmentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      assignmentID: // value for 'assignmentID'
 *   },
 * });
 */
export function useRemoveQuestionnaireAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveQuestionnaireAssignmentMutation,
    RemoveQuestionnaireAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveQuestionnaireAssignmentMutation, RemoveQuestionnaireAssignmentMutationVariables>(
    RemoveQuestionnaireAssignmentDocument,
    options
  )
}
export type RemoveQuestionnaireAssignmentMutationHookResult = ReturnType<
  typeof useRemoveQuestionnaireAssignmentMutation
>
export type RemoveQuestionnaireAssignmentMutationResult = Apollo.MutationResult<RemoveQuestionnaireAssignmentMutation>
export type RemoveQuestionnaireAssignmentMutationOptions = Apollo.BaseMutationOptions<
  RemoveQuestionnaireAssignmentMutation,
  RemoveQuestionnaireAssignmentMutationVariables
>
